<template>
  <div class="info-block">
    <svg v-svg symbol="info" size="0 0 17 17" role="info"></svg>
    <p v-html="text"></p>
  </div>
</template>
<script>
export default {
  name: "InfoBlock",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.info-block {
  position: relative;
  background: #fdfdfe;
  border: 1px solid #eeeef3;
  border-radius: 10px;
  padding: 17px 30px 17px 54px;
  font-size: 14px;
  line-height: 20px;

  &.text-center {
    padding: 17px 50px;

    p {
      text-align: center;
    }
  }

  svg {
    position: absolute;
    height: inherit;
    margin: 0;
    top: 18px;
    left: 24px;
    fill: #5183cf;
  }

  p {
    text-align: left;
    color: #141414;
    padding: 0;
    margin: 0;
  }
}
</style>
